export async function copyText(value: string, clipboard: Pick<Clipboard, "writeText"> | undefined = navigator.clipboard, targetDocument: Document = document): Promise<void> {
  if (clipboard?.writeText) { await clipboard.writeText(value); return; }
  const field = targetDocument.createElement("textarea");
  field.value = value;
  field.style.position = "fixed";
  field.style.opacity = "0";
  targetDocument.body.appendChild(field);
  field.select();
  targetDocument.execCommand("copy");
  field.remove();
}
